import { ISmartProps } from './types';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import {
	sliderRootStyles,
	sliderTrackStyles,
	sliderInnerTrackStyles,
	sliderThumbStyles,
	sliderInnerThumbStyles,
	sliderThumbValueStyles,
} from './styles';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps, ref: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const { className, children, onFinalChange, ...rest } = HTMLAttrs.rest;

	return {
		Root: {
			...sliderRootStyles(props),
			props: {
				...getBaseCustomProps(props),
				className: props.className,
				'data-epo': `epo-slider-${meta.version}`,
				...HTMLAttrs.dataProps,
				key: props.key,
				ref: ref,
			},
		},
		Track: {
			...sliderTrackStyles(),
		},
		Tick: {
			style: ({ $theme }: any) => {
				return {
					fontFamily:"var(--epods--font-base)",
					color: "var(--epods--color-text-primary)",
				};
			},
		},
		InnerTrack: {
			...sliderInnerTrackStyles(props),
		},
		Thumb: {
			...sliderThumbStyles(props),
			props: {
				...getFormCustomProps(props),
				...HTMLAttrs.ariaProps,
				...rest,
				tabIndex: props.tabIndex || 0,
				name: props.name,
				'aria-label': 'slider-thumb',
			},
		},
		InnerThumb: {
			...sliderInnerThumbStyles(props.kind),
		},
		ThumbValue: {
			...sliderThumbValueStyles(props.kind),
		},
	};
};
